import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { SafetyCertificateOutlined } from '@ant-design/icons';
import AccessGroupUsers from "./index";
import ViewAccessGroupUser from "./view";
import EditAccessGroupUser from "./edit";
import { MODULE_ACCESS_GROUPS } from "variables/constants";

const accessRightsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Access Rights",
		basePath: "access-rights",
		mainComponent: <AccessGroupUsers />,
	    layout: "/console",	   
	    icon: <SafetyCertificateOutlined className="h-6 w-6" />,
	    subTitle:"Access Rights",
	    viewComponent: <ViewAccessGroupUser />,
	    createComponent: <EditAccessGroupUser />,
	    editComponent: <EditAccessGroupUser />,
		level: 2,
		moduleId: MODULE_ACCESS_GROUPS,
	})
]

export default accessRightsRoutes;